
import '../assets/scss/mainBody.scss';
import icoStart from '../assets/icons/ico_dice.svg';
import {Howl, Howler} from 'howler';
import minTwoDigits from '../utils/minTwoDigits';
import Spinner from '../components/commons/Spinner';
import diceSound from '../assets/sounds/dice.mp3';

let [btnStart, spinnerInput, btnPlus, btnMinus] = [];
const diceSnd = new Howl({
    src: [diceSound],
    loop: false
});

class MainBody {
    constructor() {
        const elem = document.createElement('div');
        elem.classList.add('body-container');
        elem.innerHTML = `
            <div class="option-wrapper"></div>
            <div class="dice-wrapper">
                <div class="dice dice_1">
                    <div class="floor">
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                    </div>
                    <div class="cube">
                        <div class="side side_1">
                        <span class="dot dot_5"></span>
                        </div>
                        <div class="side side_2">
                        <span class="dot dot_3"></span><span class="dot dot_7"></span>
                        </div>
                        <div class="side side_3">
                        <span class="dot dot_3"></span><span class="dot dot_5"></span><span class="dot dot_7"></span>
                        </div>
                        <div class="side side_4">
                        <span class="dot dot_1"></span><span class="dot dot_3"></span><span class="dot dot_7"></span><span class="dot dot_9"></span>
                        </div>
                        <div class="side side_5">
                        <span class="dot dot_1"></span><span class="dot dot_3"></span><span class="dot dot_5"></span><span class="dot dot_7"></span><span class="dot dot_9"></span>
                        </div>
                        <div class="side side_6">
                        <span class="dot dot_1"></span><span class="dot dot_4"></span><span class="dot dot_7"></span><span class="dot dot_3"></span><span class="dot dot_6"></span><span class="dot dot_9"></span>
                        </div>
                    </div>
                </div>
                <div class="dice dice_2">
                    <div class="floor">
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                    </div>
                    <div class="cube">
                        <div class="side side_1">
                        <span class="dot dot_5"></span>
                        </div>
                        <div class="side side_2">
                        <span class="dot dot_3"></span><span class="dot dot_7"></span>
                        </div>
                        <div class="side side_3">
                        <span class="dot dot_3"></span><span class="dot dot_5"></span><span class="dot dot_7"></span>
                        </div>
                        <div class="side side_4">
                        <span class="dot dot_1"></span><span class="dot dot_3"></span><span class="dot dot_7"></span><span class="dot dot_9"></span>
                        </div>
                        <div class="side side_5">
                        <span class="dot dot_1"></span><span class="dot dot_3"></span><span class="dot dot_5"></span><span class="dot dot_7"></span><span class="dot dot_9"></span>
                        </div>
                        <div class="side side_6">
                        <span class="dot dot_1"></span><span class="dot dot_4"></span><span class="dot dot_7"></span><span class="dot dot_3"></span><span class="dot dot_6"></span><span class="dot dot_9"></span>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary btn-start"><img class="ico" src=${icoStart}>던지기</button>`;
        document.body.append(elem);

        var rollTimeout;
        let diceCount = 1;
        let diceTotal = 2;

        let optionWrapper = new Spinner(document.querySelector('.option-wrapper'), {
            val: 1,
            min: 1,
            max: 2
        });
        
        btnStart = document.querySelector('.btn-start');
        btnPlus = document.querySelector('.btn-plus');
        btnMinus = document.querySelector('.btn-minus');
        spinnerInput = document.querySelector('.spinner-input');

        btnStart.addEventListener('click', (e) => {
            e.target.disabled = true;
            btnPlus.disabled = true;
            btnMinus.disabled = true;
            // diceSnd.play();
            rollDice();

            let dices = document.querySelectorAll(".dice");
            dices.forEach((dice) => dice.classList.add("anim"));

            let objs = document.querySelectorAll(".line");
            objs.forEach((line) => line.classList.remove("anim"));

            setTimeout(() => {
                objs.forEach((line) => line.classList.add("anim"));
                document.querySelector('.cube').addEventListener("animationend", () => {
                    // flippin = false;
                    // btnStart.disabled = false;
                });
            });
        });

        window.addEventListener('keydown', (e) => {
            if(e.key == " " || e.key == "Enter"){
                if(!btnStart.disabled){
                    btnStart.disabled = true;
                    btnPlus.disabled = true;
                    btnMinus.disabled = true;
                    // diceSnd.play();
                    rollDice();

                    let dices = document.querySelectorAll(".dice");
                    dices.forEach((dice) => dice.classList.add("anim"));

                    let objs = document.querySelectorAll(".line");
                    objs.forEach((line) => line.classList.remove("anim"));

                    setTimeout(() => {
                        objs.forEach((line) => line.classList.add("anim"));
                        document.querySelector('.cube').addEventListener("animationend", () => {
                            // flippin = false;
                            // btnStart.disabled = false;
                        });
                    });
                }
            }
        });

        //부모에서 키이벤트를 받아 처리하는 부분(231122)
        window.addEventListener('message', (e) => {
            // console.log('iframe postmessage', e.data.key)
            if(e.data.key === 'Enter' || e.data.key === ' '){
                if(!btnStart.disabled){
                    btnStart.disabled = true;
                    btnPlus.disabled = true;
                    btnMinus.disabled = true;
                    // diceSnd.play();
                    rollDice();

                    let dices = document.querySelectorAll(".dice");
                    dices.forEach((dice) => dice.classList.add("anim"));

                    let objs = document.querySelectorAll(".line");
                    objs.forEach((line) => line.classList.remove("anim"));

                    setTimeout(() => {
                        objs.forEach((line) => line.classList.add("anim"));
                        document.querySelector('.cube').addEventListener("animationend", () => {
                            // flippin = false;
                            // btnStart.disabled = false;
                        });
                    });
                }
            }
        });

        btnPlus.addEventListener('click', controlDice);
        btnMinus.addEventListener('click', controlDice);

        function controlDice() {
            // console.log('value', spinnerInput.value);
            let objs = document.querySelectorAll(".line");
            objs.forEach((line) => line.classList.remove("anim"));
            
            diceCount = spinnerInput.value;
            for(let i=0; i<diceTotal; i++){
                if(i < diceCount){
                    document.querySelector(`.dice_${i+1}`).style.display = 'block';
                }else{
                    document.querySelector(`.dice_${i+1}`).style.display = 'none';
                }
            }
        }
  
        function setVal(num, val) {
            var dices = document.querySelectorAll('.dice');
            var dice = dices.item(num - 1);
            if (!dice) return;
            dice.setAttribute('data-val', val);
        }
        
        function toggleRoll() {
            for(let i=0; i<diceCount; i++){
                setVal(i+1, 0);
            }
        }

        function getRand() {
            return Math.round(Math.random() * 5 + 1);
        }
        
        function setVals() {
            for(let i=0; i<diceCount; i++){
                setVal(i+1, getRand());
            }
        }

        function rollDice() {
            if (rollTimeout) clearTimeout(rollTimeout);
            toggleRoll();
            rollTimeout = setTimeout(function() {
                setVals();
                setTimeout(() => {
                    btnStart.disabled = false;
                    btnPlus.disabled = false;
                    btnMinus.disabled = false;
                    let dices = document.querySelectorAll(".dice");
                    dices.forEach((dice) => dice.classList.remove("anim"));
                    diceSnd.play();
                }, 600); 
            }, 1000);
        }
    }

}
export default MainBody;